/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex';
import { moduleActionContext, moduleGetterContext } from '@/plugins/vuex';
import isEmpty from 'lodash/isEmpty';
import { TransformOptions } from '@aison/migrator';
import { SimpleTransformField } from '@/types';
import * as transformers from '@aison/migrator/lib/transformers';

export interface TransformState {
  type?: transformers.TransformType;
  options: transformers.TransformerOptions;
}

const initialState = (): TransformState => ({
  type: 'simple',
  options: {},
});

const module = defineModule({
  namespaced: true,
  state: initialState,
  getters: {
    type: (...args) => transformGetterContext(args).state.type,
    transformer(...args) {
      const { state } = transformGetterContext(args);
      if (state.options.map && !isEmpty(state.options.map)) {
        return new transformers.SimpleTransformer(state.options);
      }
      return null;
    },
    previewSourceObject: (...args) => {
      const { rootState, rootGetters } = transformGetterContext(args);
      if (rootGetters.read.dataLoaded) {
        return rootState.read.data[0];
      }
    },
    previewTransformedObject: (...args) => {
      const { getters, rootGetters, rootState } = transformGetterContext(args);
      if (!rootGetters.read.dataLoaded || !getters.transformer) {
        return {};
      }
      return getters.transformer.transform(rootState.read.data[0]);
    },
    config(...args): TransformOptions[] {
      const { state } = transformGetterContext(args);
      return [
        {
          type: state.type,
          options: state.options,
        },
      ];
    },
    sourceAvailableFields(...args): SimpleTransformField[] {
      const { state, rootGetters } = transformGetterContext(args);
      return rootGetters.read.fields;
      // return rootGetters.read.fields.filter(field =>
      //   state.options.map
      //     ? !Object.values(state.options.map).includes(field.value)
      //     : true
      // );
    },
    targetAvailableFields(...args): SimpleTransformField[] {
      const { state, rootGetters } = transformGetterContext(args);
      return rootGetters.target.fields.filter(field =>
        state.options.map
          ? !Object.keys(state.options.map).includes(field.value)
          : true
      );
    },
  },
  mutations: {
    reset(state, options = {}) {
      Object.assign(state, initialState(), options);
    },
    setOptions(state, options: transformers.TransformerOptions) {
      state.options = options;
    },
  },
  actions: {
    reset(context, payload: TransformOptions[]) {
      const { commit } = transformActionContext(context);
      const options = payload && payload.length ? payload[0] : {};
      // TODO: Parse values into options properlyyy
      commit.reset(options);
    },
  },
});

const transformGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, module);
const transformActionContext = (context: any) =>
  moduleActionContext(context, module);

export default module;
